import { useContext } from "react";
import { DataScopeContext, type DataScopeValue } from "@/contexts/DataScopeContext";

export function useDataScope(): DataScopeValue {
  const ctx = useContext(DataScopeContext);
  if (!ctx) throw new Error("useDataScope must be used within DataScopeProvider");
  return ctx;
}

export type { DataScopeValue };
